export const KEYBOARD_CODES = {
    Backspace: 8,
    Tab: 9,
    Enter: 13,
    Shift: 16,
    Ctrl: 17,
    Alt: 18,
    PauseBreak: 19,
    CapsLock: 20,
    Escape: 27,
    Space: 32,
    PageUp: 33,
    PageDown: 34,
    End: 35,
    Home: 36,
    LeftArrow: 37,
    UpArrow: 38,
    RightArrow: 39,
    DownArrow: 40,
    Insert: 45,
    Delete: 46,
    Number0: 48,
    Number1: 49,
    Number2: 50,
    Number3: 51,
    Number4: 52,
    Number5: 53,
    Number6: 54,
    Number7: 55,
    Number8: 56,
    Number9: 57,
    LetterA: 65,
    LetterB: 66,
    LetterC: 67,
    LetterD: 68,
    LetterE: 69,
    LetterF: 70,
    LetterG: 71,
    LetterH: 72,
    LetterI: 73,
    LetterJ: 74,
    LetterK: 75,
    LetterL: 76,
    LetterM: 77,
    LetterN: 78,
    LetterO: 79,
    LetterP: 80,
    LetterQ: 81,
    LetterR: 82,
    LetterS: 83,
    LetterT: 84,
    LetterU: 85,
    LetterV: 86,
    LetterW: 87,
    LetterX: 88,
    LetterY: 89,
    LetterZ: 90,
    LeftWindowKey: 91,
    RightWindowKey: 92,
    SelectKey: 93,
    Numpad0: 96,
    Numpad1: 97,
    Numpad2: 98,
    Numpad3: 99,
    Numpad4: 100,
    Numpad5: 101,
    Numpad6: 102,
    Numpad7: 103,
    Numpad8: 104,
    Numpad9: 105,
    Multiply: 106,
    Add: 107,
    Subtract: 109,
    DecimalPoint: 110,
    Divide: 111,
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    NumLock: 144,
    ScrollLock: 145,
    SemiColon: 186,
    EqualSign: 187,
    Comma: 188,
    Dash: 189,
    Period: 190,
    ForwardSlash: 191,
    GraveAccent: 192,
    OpenBracket: 219,
    BackSlash: 220,
    CloseBraket: 221,
    SingleQuote: 222,
};

export function isUndo(e) {
    return (e.ctrlKey || e.metaKey)
        && e.which === (e.shiftKey ? KEYBOARD_CODES.LetterY : KEYBOARD_CODES.LetterZ);
}

export function isRedo(e) {
    return (e.ctrlKey || e.metaKey)
        && e.which === (e.shiftKey ? KEYBOARD_CODES.LetterZ : KEYBOARD_CODES.LetterY);
}

export function isNumber(code) {
    return code >= KEYBOARD_CODES.Number0 && code <= KEYBOARD_CODES.Number9;
}

export function isPrintable(code) {
    return code >= KEYBOARD_CODES.Number0 && code <= KEYBOARD_CODES.Number9
        || code === KEYBOARD_CODES.Space
        || code === KEYBOARD_CODES.Enter
        || code >= KEYBOARD_CODES.LetterA && code <= KEYBOARD_CODES.LetterZ
        || code >= KEYBOARD_CODES.Numpad0 && code <= KEYBOARD_CODES.Divide
        || code >= KEYBOARD_CODES.SemiColon && code <= KEYBOARD_CODES.GraveAccent
        || code >= KEYBOARD_CODES.OpenBracket && code <= KEYBOARD_CODES.SingleQuote;
}

export function isSubmit(code) {
    return code === KEYBOARD_CODES.Enter || code === KEYBOARD_CODES.Space;
}
